import {required} from "vuelidate/lib/validators";  
const configtranslations = {
    data() { 
      return {   
        configtranslationsData: {    
          Sitebaslik:  null,
          Siteanahtarkelimeler:  null,
          Siteaciklama:  null, 
          Contactaddress:  null,
          Contactphone:  null,
          Contactfax:  null,
          Contactemail:  null,
          Contactmap:  null, 
          Sitelogo:  null, 
          Introductionvideo:  null,
          Homepagetext:  null,
          Configid:  null,
          Langid:  null,
          Websiteid: null,
          Kvkkmetni:  null 
          }, 
          FormDataType:{ 
            Sitebaslik:{FieldName:"Sitebaslik",Field:"input",FieldTitle:this.$t('configs.AddEdit.SeoAyarlari.Sitebaslik'),FieldType:"text"},
            Siteanahtarkelimeler:{FieldName:"Siteanahtarkelimeler",Field:"input",FieldTitle:this.$t('configs.AddEdit.SeoAyarlari.Siteanahtarkelimeler'),FieldType:"text"},
            Siteaciklama:{FieldName:"Siteaciklama",Field:"input",FieldTitle:this.$t('configs.AddEdit.SeoAyarlari.Siteaciklama'),FieldType:"text"},
            Contactaddress:{FieldName:"Contactaddress",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactaddress'),FieldType:"text"},
            Contactphone:{FieldName:"Contactphone",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactphone'),FieldType:"text"},
            Contactfax:{FieldName:"Contactfax",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactfax'),FieldType:"text"},
            Contactemail:{FieldName:"Contactemail",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactemail'),FieldType:"text"},
            Contactmap:{FieldName:"Contactmap",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactmap'),FieldType:"text"},
            Sitelogo:{FieldName:"Sitelogo",Field:"input",FieldTitle:this.$t('configs.AddEdit.Gorseller.Sitelogo'),FieldType:"text"}, 
            Introductionvideo:{FieldName:"Introductionvideo",Field:"input",FieldTitle:this.$t('configs.AddEdit.Gorseller.Introductionvideo'),FieldType:"text"}, 
            Kvkkmetni:{FieldName:"Kvkkmetni",Field:"textarea",FieldTitle:this.$t('configs.AddEdit.Kvkk.Kvkkmetni'),FieldType:"text"}, 
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Sitebaslik: { required},  
        Siteanahtarkelimeler: {  }, 
        Siteaciklama: {  },   
        Contactaddress: {  },  
        Contactphone: {  },  
        Contactfax: {  },  
        Contactemail: {  },  
        Contactmap: {  },   
        Sitelogo: {  },   
        Introductionvideo: {  } , 
        Kvkkmetni: {  } 
      }
 
  }, 
  created(){ 
  } 

}
export default configtranslations